"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avalanche = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Avalanche = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "avalanche", viewBox: "0 0 258 238", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "avalanche", viewBox: "0 0 258 238", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M257.637 229.877 193.181 88.831c-1.617-3.242-5.645-3.242-7.262 0l-25.385 45.743-56.4-132.143c-1.616-3.242-5.645-3.242-6.843 0L.607 229.877c-1.719 3.466.44 8.123 3.63 8.123h249.77c2.685 0 4.887-3.018 3.63-8.123z", fill: "#929aad", fillRule: "evenodd" }) })) })));
};
exports.Avalanche = Avalanche;
